import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoSlides = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 33 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>Slides</title>
    <path
      d="M21.434 6.844h.517c.63 0 1.142.511 1.142 1.143v16.025c0 .63-.511 1.143-1.142 1.143h-.517M26.518 9.388h.527c.632 0 1.143.512 1.143 1.143V21.47c0 .631-.511 1.143-1.143 1.143h-.527"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <rect
      x={5.807}
      y={4.81}
      width={12.207}
      height={22.38}
      rx={1.143}
      stroke="currentColor"
      strokeWidth={2}
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgIcoSlides;
